import { dealerPartnerNumber, toDealerSelection } from './dealerOptions';

export const applyCampaignRequest = (event, request, dealerCatalog = []) => {
  const config = request.approvedConfig;
  if (!config || request.status !== 'approved') return event;
  const selectedDealers = (config.dealerCodes || [])
    .map((code) => {
      const partner = dealerPartnerNumber(code);
      const dealer = dealerCatalog.find((item) => partner && dealerPartnerNumber(item.porschePartnerNo || item.code) === partner);
      return dealer ? { ...toDealerSelection(dealer), code } : null;
    })
    .filter(Boolean);
  return {
    ...event,
    allowPushToCap: true,
    campaignCodeVerified: true,
    capRequestId: request.id,
    capRequestRevision: request.revision,
    capConfig: config,
    capEndExportCompleted: event.capRequestId === request.id &&
      event.capRequestRevision === request.revision ? !!event.capEndExportCompleted : false,
    startDate: config.eventDate,
    endDate: config.eventEndDate,
    ongoingEvent: config.schedule === 'ongoing',
    campaignCode: config.leadCampaignCode,
    campaignDescription: config.leadCampaignDescription,
    campaignAltCode: config.ihCampaignCode,
    campaignAltDescription: config.ihCampaignDescription,
    campaignComments: config.campaignComments || '',
    checkedInLeads: config.leadTrigger === 'checkedIn',
    skipDealerOptIn: config.leadTrigger !== 'optIn',
    hideDealerOptInOnWaitlist: false,
    endOfEvent: config.schedule === 'end',
    dealersSelected: config.dealerMode === 'multi' ? selectedDealers : [],
    dataFields: {
      ...event.dataFields,
      modelInterest: config.leadTrigger === 'checkedIn' ?
        { ...event.dataFields?.modelInterest } : { ...event.dataFields?.modelInterest, visible: config.modelInterest,
        required: config.leadTrigger === 'optIn', hideOnWaitlist: false },
      purchaseTimeFrame: config.leadTrigger === 'checkedIn' ?
        { ...event.dataFields?.purchaseTimeFrame } : { ...event.dataFields?.purchaseTimeFrame, visible: config.purchaseTimeFrame,
        required: config.leadTrigger === 'optIn', hideOnWaitlist: false },
      experience: config.leadTrigger === 'checkedIn' ?
        { ...event.dataFields?.experience } : { ...event.dataFields?.experience, visible: config.porscheExperience,
        required: false, hideOnWaitlist: false },
      dealer: { ...event.dataFields?.dealer, visible: ['multi', 'all'].includes(config.dealerMode),
        required: config.dealerMode === 'multi', hideOnWaitlist: false },
    },
  };
};

export const requiresApprovedCampaignRequest = (event, originalEvent) =>
  !!event?.allowPushToCap &&
  !(originalEvent?.allowPushToCap && !originalEvent?.capRequestId && !event.capRequestId);

export const campaignRequestMismatch = (event, request) => {
  const config = request?.approvedConfig;
  const sameSnapshot = config && Object.keys(config).every((key) =>
    Array.isArray(config[key])
      ? JSON.stringify([...(event?.capConfig?.[key] || [])].sort()) === JSON.stringify([...config[key]].sort())
      : event?.capConfig?.[key] === config[key]);
  if (!config || request.status !== 'approved' || !event?.capRequestId ||
      !event.campaignCodeVerified ||
      event.capRequestId !== request.id || event.capRequestRevision !== request.revision ||
      !sameSnapshot) return true;
  const selectedCodes = (event.dealersSelected || []).map((dealer) => dealer.code).sort();
  if (config.dealerMode === 'multi' &&
      JSON.stringify(selectedCodes) !== JSON.stringify([...(config.dealerCodes || [])].sort())) return true;
  return event.startDate !== config.eventDate || (event.endDate || '') !== config.eventEndDate ||
    event.campaignCode !== config.leadCampaignCode ||
    event.campaignDescription !== config.leadCampaignDescription ||
    event.campaignAltCode !== config.ihCampaignCode ||
    event.campaignAltDescription !== config.ihCampaignDescription ||
    (Object.prototype.hasOwnProperty.call(config, 'campaignComments') &&
      (event.campaignComments || '') !== (config.campaignComments || '')) ||
    !!event.ongoingEvent !== (config.schedule === 'ongoing') ||
    event.checkedInLeads !== (config.leadTrigger === 'checkedIn') ||
    !!event.skipDealerOptIn !== (config.leadTrigger !== 'optIn') ||
    (Object.prototype.hasOwnProperty.call(config, 'externalUse') &&
      !!event.hideDealerOptInOnWaitlist) ||
    event.endOfEvent !== (config.schedule === 'end') ||
    (config.leadTrigger !== 'checkedIn' && (
      !!event.dataFields?.modelInterest?.visible !== config.modelInterest ||
      !!event.dataFields?.modelInterest?.required !== (config.leadTrigger === 'optIn') ||
      !!event.dataFields?.purchaseTimeFrame?.visible !== config.purchaseTimeFrame ||
      !!event.dataFields?.purchaseTimeFrame?.required !== (config.leadTrigger === 'optIn') ||
      !!event.dataFields?.experience?.visible !== config.porscheExperience ||
      !!event.dataFields?.experience?.required)) ||
    !!event.dataFields?.dealer?.visible !== ['multi', 'all'].includes(config.dealerMode) ||
    !!event.dataFields?.dealer?.required !== (config.dealerMode === 'multi') ||
    (Object.prototype.hasOwnProperty.call(config, 'externalUse') &&
      (config.leadTrigger === 'checkedIn' ? ['dealer'] :
        ['modelInterest', 'purchaseTimeFrame', 'experience', 'dealer'])
        .some((key) => !!event.dataFields?.[key]?.hideOnWaitlist));
};
